import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ProdottoVariante} from "../../../../../../../models/ProdottoVariante";

@Component({
   selector: 'app-pvariant-instance-modal',
   templateUrl: './pvariant-instance-modal.component.html',
   styleUrls: ['./pvariant-instance-modal.component.scss']
})
export class PVariantInstanceModalComponent implements OnInit {

   constructor(@Inject(MAT_DIALOG_DATA) public data: {
                  excludeNotOrdered: boolean;
                  pVenditaID: any;
                  vendorSlug: string;
                  pVariant:ProdottoVariante,
                  pVariantIds:number[],
                  isModal:boolean
               },
               private dialogRef: MatDialogRef<PVariantInstanceModalComponent>) { }

   ngOnInit(): void {
   }

   addPVariantInstance(e: any) {
      this.dialogRef.close({pVariant:e})
   }
}
